import LegalPageLayout from "@/components/LegalPageLayout";

const SECTIONS = [
  {
    title: "Allmänt",
    body: [
      "Dessa allmänna villkor reglerar användningen av Hundify, ett molnbaserat affärssystem för hundpensionat, hunddagis, hundrastnings­verksamheter och liknande hundverksamheter. Genom att teckna abonnemang eller på annat sätt använda tjänsten godkänner du dessa villkor.",
      "Villkoren utgör ett bindande avtal mellan Hundify (i fortsättningen \"Leverantören\") och den juridiska person eller näringsidkare som tecknar abonnemang (i fortsättningen \"Kunden\").",
    ],
  },
  {
    title: "Tjänsten",
    body: [
      "Tjänsten består av ett molnbaserat affärssystem för hantering av bokningar, kunder, hundprofiler, fakturering, schemaläggning och relaterade funktioner. Tjänstens exakta omfattning beror på den abonnemangs­plan Kunden valt.",
      "Leverantören utvecklar tjänsten löpande och förbehåller sig rätten att lägga till, ändra eller ta bort funktioner under förutsättning att de grundläggande funktionerna i Kundens valda abonnemangs­plan upprätthålls.",
    ],
  },
  {
    title: "Konto och inloggning",
    body: [
      "Kunden ansvarar för att skapa konton till sina användare och att hålla inloggningsuppgifter konfidentiella. Kunden ansvarar för alla aktiviteter som sker via sina konton.",
      "Vid misstanke om obehörig åtkomst ska Kunden omedelbart kontakta Leverantören och byta lösenord. Leverantören rekommenderar starkt att tvåfaktors­autentisering aktiveras.",
    ],
  },
  {
    title: "Abonnemang och betalning",
    body: [
      "Abonnemang löper tills vidare och förnyas automatiskt enligt vald betalningsperiod (månadsvis eller årsvis) såvida det inte sägs upp. Priset för abonnemanget framgår vid beställning och kan komma att justeras med skälig varseltid.",
      "Fakturering sker i förskott. Vid utebliven betalning förbehåller sig Leverantören rätten att stänga av åtkomsten till tjänsten tills full betalning skett. Påminnelseavgift och dröjsmålsränta tillämpas enligt gällande lagstiftning.",
      "Samtliga priser anges exklusive lagstadgad mervärdesskatt om inte annat uttryckligen anges.",
    ],
  },
  {
    title: "Uppsägning och avtalstid",
    body: [
      "Månadsabonnemang kan sägas upp inför nästkommande månadsperiod. Årsabonnemang kan sägas upp inför nästkommande årsperiod. Uppsägning sker via tjänsten eller skriftligen till Leverantörens kundtjänst.",
      "Vid uppsägning behåller Kunden tillgång till tjänsten till slutet av den aktuella betalningsperioden. Redan inbetalda avgifter återbetalas inte.",
      "Leverantören har rätt att med omedelbar verkan säga upp avtalet om Kunden väsentligt bryter mot dessa villkor, exempelvis genom missbruk av tjänsten eller utebliven betalning trots påminnelser.",
    ],
  },
  {
    title: "Användarens skyldigheter",
    body: [
      "Kunden förbinder sig att:",
      [
        "Endast använda tjänsten i enlighet med dessa villkor och tillämplig lagstiftning.",
        "Inte ladda upp innehåll som är olagligt, kränkande eller på annat sätt olämpligt.",
        "Inte försöka kringgå tekniska säkerhetsåtgärder eller åtkomstbegränsningar.",
        "Säkerställa att de personer som registreras i tjänsten (till exempel kunder, anställda och hundägare) har informerats i den utsträckning som krävs enligt GDPR.",
        "Hålla sina kontaktuppgifter aktuella i tjänsten för att kunna ta emot viktig information.",
      ],
    ],
  },
  {
    title: "Data och personuppgifter",
    body: [
      "Kunden behåller äganderätten till all data och allt innehåll som laddas upp i tjänsten. Leverantören får endast använda kundens data för att tillhandahålla och förbättra tjänsten.",
      "Leverantören agerar personuppgiftsbiträde åt Kunden för de personuppgifter som behandlas i tjänsten. Ett separat personuppgiftsbiträdes­avtal (PUB-avtal) finns tillgängligt och utgör en del av detta avtal vid abonnemangstecknande.",
      "Vid uppsägning kan Kunden exportera sin data i ett standardformat under en period av 30 dagar från avtalets upphörande. Därefter raderas data permanent.",
    ],
  },
  {
    title: "Tillgänglighet och support",
    body: [
      "Leverantören strävar efter att tjänsten ska vara tillgänglig dygnet runt. Planerat underhåll utförs i möjligaste mån utanför kontorstid och aviseras i förväg när det är praktiskt möjligt.",
      "Supportnivåer (responstid, kanaler) framgår av Kundens valda abonnemangs­plan. Enterprise-kunder kan teckna separat SLA med utökade garantier.",
    ],
  },
  {
    title: "Ansvarsbegränsning",
    body: [
      "Leverantörens ansvar är begränsat till direkta skador och uppgår till maximalt det belopp Kunden har betalat för tjänsten under de senaste tolv (12) månaderna före den skadeståndsgrundande händelsen.",
      "Leverantören ansvarar inte för indirekta skador såsom utebliven vinst, förlorad omsättning, förlorade data utöver tillämpliga säkerhetskopior, eller skador på tredje part.",
      "Begränsningen gäller inte vid uppsåt eller grov vårdslöshet från Leverantörens sida.",
    ],
  },
  {
    title: "Force majeure",
    body: [
      "Ingen av parterna ansvarar för utebliven prestation som beror på omständigheter utanför partens rimliga kontroll, såsom naturkatastrof, krig, omfattande arbetsmarknads­konflikt, sabotage, omfattande störningar i internet- eller elnät, eller myndighetsåtgärder.",
    ],
  },
  {
    title: "Ändringar i villkoren",
    body: [
      "Leverantören förbehåller sig rätten att uppdatera dessa villkor. Väsentliga förändringar meddelas i god tid via e-post eller direkt i tjänsten. Om Kunden inte accepterar ändringarna har Kunden rätt att säga upp avtalet inför nästa betalningsperiod.",
    ],
  },
  {
    title: "Tillämplig lag och tvister",
    body: [
      "Svensk lag är tillämplig på detta avtal. Eventuella tvister ska i första hand lösas genom förhandling mellan parterna. Om en överenskommelse inte kan nås, ska tvisten avgöras av allmän domstol med Stockholms tingsrätt som första instans.",
    ],
  },
];

export default function TermsPage() {
  return (
    <LegalPageLayout
      testid="page-terms"
      category="Användarvillkor"
      title="Allmänna villkor"
      lastUpdated="December 2026"
      sections={SECTIONS}
      seoDescription="Allmänna villkor för Hundify — det molnbaserade affärssystemet för hundverksamheter. Avtalsvillkor, betalning, uppsägning och ansvarsbegränsning."
      seoPath="/villkor"
    />
  );
}
